import React from 'react';
import HeaderRow from './components/header-row';

type Props = {
  children?: React.ReactNode;
  className?: string;
  dataBotify?: string;
  displayOptions?: React.ReactNode;
  sortOptions?: React.ReactNode;
  subtitle?: string;
  title?: string;
  noMarginBottom?: boolean;
};

export const ProductsHeader = (props: Props) => {
  const {
    children,
    className,
    dataBotify,
    displayOptions,
    sortOptions,
    subtitle,
    title,
    noMarginBottom = false,
  } = props;

  return (
    <div>
      <HeaderRow
        className={className}
        data-botify={dataBotify}
        displayOptions={displayOptions}
        sortOptions={sortOptions}
        subtitle={subtitle}
        title={title}
        noMarginBottom={noMarginBottom}
      />
      {children}
    </div>
  );
};
